module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"csvDownload":"Download CSV file","downloading":"Downloading..."},"ja":{"csvDownload":"CSVファイルでダウンロード","downloading":"ダウンロード中..."},"zh-hant":{"csvDownload":"下載為CSV文件檔","downloading":"下載中..."},"zh-hans":{"csvDownload":"下载为CSV文件档","downloading":"下载中..."}}')
  delete Component.options._Ctor
}
